import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SiteLeadReferralList from './SiteLeadReferralList';
import {
  assignSpoc,
  centralValidate,
  getReferralList,
  getRejectReasons,
  getSpocList,
  getStatusHistory,
  rejectLead,
  validateLead,
  setLeadStage,
} from 'services/redux/siteLeadReferral/action';

const mapStateToProps = (state) => ({
  referralList: state.siteLeadReferralReducer.referralList,
  spocOptions: state.siteLeadReferralReducer.spocOptions,
  rejectReasons: state.siteLeadReferralReducer.rejectReasons,
  statusHistory: state.siteLeadReferralReducer.statusHistory,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getReferralList,
      getSpocList,
      getRejectReasons,
      getStatusHistory,
      assignSpoc,
      validateLead,
      rejectLead,
      centralValidate,
      setLeadStage,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteLeadReferralList);
